/**
 * @generated SignedSource<<afd8ec94c8ecc60c650e83821bbac0a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type MeetingCopilotAutoShareSettingsMutation$variables = {
  alwaysEmailWhenAttendee: boolean;
  autoShareSendTo: UserMeetingRecapSendTo;
};
export type MeetingCopilotAutoShareSettingsMutation$data = {
  readonly updateUserMeetingRecapAutoShareSettings: {
    readonly settings: {
      readonly alwaysEmailWhenAttendee: boolean;
      readonly id: string;
      readonly sendTo: UserMeetingRecapSendTo;
    } | null;
  } | null;
};
export type MeetingCopilotAutoShareSettingsMutation = {
  response: MeetingCopilotAutoShareSettingsMutation$data;
  variables: MeetingCopilotAutoShareSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "alwaysEmailWhenAttendee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoShareSendTo"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "alwaysEmailWhenAttendee",
        "variableName": "alwaysEmailWhenAttendee"
      },
      {
        "kind": "Variable",
        "name": "sendTo",
        "variableName": "autoShareSendTo"
      }
    ],
    "concreteType": "UpdateUserMeetingRecapAutoShareSettings",
    "kind": "LinkedField",
    "name": "updateUserMeetingRecapAutoShareSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserMeetingRecapAutoShareSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alwaysEmailWhenAttendee",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCopilotAutoShareSettingsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingCopilotAutoShareSettingsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8c45573bb28807ad2e6a09c9cbc7f4fa",
    "id": null,
    "metadata": {},
    "name": "MeetingCopilotAutoShareSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingCopilotAutoShareSettingsMutation(\n  $autoShareSendTo: UserMeetingRecapSendTo!\n  $alwaysEmailWhenAttendee: Boolean!\n) {\n  updateUserMeetingRecapAutoShareSettings(sendTo: $autoShareSendTo, alwaysEmailWhenAttendee: $alwaysEmailWhenAttendee) {\n    settings {\n      id\n      sendTo\n      alwaysEmailWhenAttendee\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f91f6cfd9708c28ff863af5ebd126e68";

export default node;
